import { Component, ElementRef, HostListener, ViewChild, Input, OnInit, OnDestroy } from '@angular/core';
import { ReplaySubject, Subscription } from 'rxjs';

@Component({
	selector: 'bb-scrollable-pane',
	templateUrl: './bb-scrollable-pane.component.html',
	styleUrls: ['./bb-scrollable-pane.component.scss']
})
export class BbScrollablePaneComponent implements OnInit, OnDestroy {
	@Input() lockScrollObs: ReplaySubject<any>;
	@ViewChild('contentEl', { static: true }) contentElRef: ElementRef;
	@ViewChild('wrapperEl', { static: true }) wrapperElRef: ElementRef;
	scrollable: HTMLElement;
	content: HTMLElement;
	showToLeftArrow = false;
	showToRightArrow = true;
	init: boolean;
	minimumScrollSpeed = 100;
	lockScroll = false;

	private subscriptions = new Subscription();

	constructor() { }

	@HostListener('window:resize', ['$event'])
	onWindowResize(ev: Event) {
		this.updateArrows(this.scrollable, this.content);
	}

	@HostListener('wheel', ['$event'])
	onWheel(ev: WheelEvent) {
		const maxDelta = Math.max(ev.deltaX, ev.deltaY);
		const max = maxDelta > 0 ? Math.max(this.minimumScrollSpeed, maxDelta) : maxDelta;
		const minDelta = Math.min(ev.deltaX, ev.deltaY);
		const min = minDelta < 0 ? Math.min(-this.minimumScrollSpeed, minDelta) : minDelta;
		const dir = (max > 0 ? max : min);
		const scrollTo = Math.min(this.content.scrollWidth, Math.max(0, this.scrollable.scrollLeft + dir));
		if (!this.lockScroll) { // only needs lockscroll on mousewheel; when clicked outside, dropdown closes
			this.scrollable.scrollTo({
				left: scrollTo,
				// behavior: 'smooth' // turned off here to prevent having to deal with fast subsequent wheel events
			});
		}
	}

	ngOnInit() {
		this.scrollable = this.wrapperElRef.nativeElement;
		this.content = this.contentElRef.nativeElement;
		this.updateArrows(this.scrollable, this.content);
		this.init = true;

		if (this.lockScrollObs) {
			this.subscriptions.add(this.lockScrollObs.subscribe((disableScroll: any) => {
				this.lockScroll = disableScroll;
			}));
		}
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	public update() {
		this.updateArrows(this.scrollable, this.content);
	}

	onScroll() {
		// console.warn('on scroll ', ev);
		this.updateArrows(this.scrollable, this.content);
	}

	scrollTo(dir: string) {
		const scrollTo = dir === 'right' ? this.content.scrollWidth : 0;

		this.scrollable.scrollTo({
			left: scrollTo,
			behavior: 'smooth'
		});
	}

	updateArrows(scrollable: HTMLElement, content: HTMLElement) {
		// console.warn(this.scrollable.scrollLeft, this.scrollable.offsetWidth, this.content.scrollWidth)
		// 	this.scrollable.scrollLeft + this.scrollable.offsetWidth, 'content scrollwidth', this.content.scrollWidth)
		if (!this.scrollable || !this.content) {
			return;
		}
		this.showToLeftArrow = this.scrollable.scrollLeft > 0;
		// this.showToRightArrow = this.scrollable.offsetWidth < this.content.scrollWidth;
		this.showToRightArrow = (this.scrollable.scrollLeft + this.scrollable.offsetWidth) < this.content.scrollWidth - 1;
	}
}
